export const logToConsole = (...args: any[]) => {
  // eslint-disable-next-line no-console
  console.log(...args)
}
